import { WalletResponseDto } from "../dto/response/wallet-response-dto";
import { Wallet } from "../model/wallet.model";

export function fromWalletResponseToWallet(dto: WalletResponseDto): Wallet {
  return {
    id: dto.id,
    pixKey: dto.pixKey,
    userId: dto.userId,
    balance: dto.balance,
    pendingBalance: dto.pendingBalance,
    type: dto.type,
    currency: dto.currency,
    status: dto.status,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    transactions: { data: [] as any }} as Wallet;
}
